import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	row: {
		display: 'flex',
		alignItems: 'center',
		gap: THEME.spacing.sm,
		flex: 1,
		minWidth: 0,
	},
	// The operator picker carries the longest text ("greater than or equal to"),
	// so it takes the row's free space while the threshold keeps a fixed width.
	operator: {
		flex: 1,
		minWidth: 0,
	},
	operatorInput: {
		width: '100%',
	},
	comboboxItemLabel: {
		flex: 1,
		minWidth: 0,
	},
	threshold: {
		width: 72,
		flex: '0 0 auto',
	},
});
